export default __webpack_public_path__ + "static/media/tempStore4.0575be52.png";